
  const page = {
    path: "/manage-pages",
    name: "managePages",
    component: () => import(/* webpackChunkName: "managePages" */ "@/components/page/ManagePages.vue"),
    meta: { authorize: [], requiresAuth: true }
  };

export default page;
    